export const bookingHeaders = [
    {
        name: 'ACTUALIZADO',
        value: 'updatedAt'
    },
    {
        name: 'SERVICIO',
        value: 'name'
    },
    {
        name: 'DÍA Y HORA',
        value: 'date'
    },
    {
        name: 'ADICIONAL',
        value: 'description'
    },
    {
        name: 'NOMBRE',
        value: 'username'
    },
    {
        name: 'EMAIL',
        value: 'email'
    },
    {
        name: 'PAIS',
        value: 'country'
    },
    {
        name: 'TELÉFONO',
        value: 'phone'
    },
    {
        name: 'DÍAS SERVCIO',
        value: 'day'
    },
    {
        name: 'HORARIO',
        value: 'time'
    },
    {
        name: 'TYPO',
        value: 'type'
    },
    {
        name: 'CANTIDAD',
        value: 'realQty'
    },
    {
        name: 'TOTAL',
        value: 'realPrice'
    },
    {
        name: 'PAGO CONFIRMADO',
        value: 'isPaid'
    },
]

export const serviceHeaders = [
    {
        name: 'SERVICIO',
        value: 'name'
    },
    {
        name: 'DÍAS SERVCIO',
        value: 'day'
    },
    {
        name: 'HORARIO',
        value: 'time'
    },
    {
        name: 'TYPO',
        value: 'type'
    },
    {
        name: 'DURACIÓN (HS)',
        value: 'duration'
    },
    {
        name: 'ES EVENTO',
        value: 'isEvent'
    },
    {
        name: 'PRECIO (US $)',
        value: 'price'
    },
]

export const eventHeaders = [
    {
        name: 'EVENTO',
        value: 'name'
    },
    {
        name: 'DÍA Y HORA',
        value: 'date'
    },
    {
        name: 'DURACIÓN (HS)',
        value: 'duration'
    },
    {
        name: 'PARTICIPANTES',
        value: 'participants'
    },
    {
        name: 'ES VIRTUAL',
        value: 'isVirtual'
    },
    {
        name: 'PRECIO (US $)',
        value: 'price'
    },
]